<div class="dialog-title">Register Lead</div>

<div style="padding-bottom: 20px;">
    <div class="content-wrapper full text-center">
        <qrcode *ngIf="campaignLink" [qrdata]="campaignLink" [width]="150" [errorCorrectionLevel]="'M'"></qrcode>
        <div class="fs-12 regular-font color-grey">
            Scan the QR Code to register
        </div>
    </div>
    <div class="content-wrapper full text-center">
        <div class="input-with-btn">
            <div class="desc-f">
                {{ campaignLink }}
            </div>
            <button class="the-btn" mat-flat-button [cdkCopyToClipboard]="campaignLink" (click)="clickShare()">
                <mat-icon class="indicator-16 blueIcon">content_copy</mat-icon>
            </button>
        </div>
    </div>
</div>